export const DECODER_STATUS = {
  PLAYING: 'playing',
  PAUSED: 'paused',
  IDLE: 'idle',
  OFFLINE: 'offline',
} as const;

export const MAX_DESCRIPTION_LENGTH = 5000;
